import Blog2GridRightContainer from "../../../../components/pages/blog/blogPage/Blog2GridRight";

const Blog2GridRight = () => {
  return <Blog2GridRightContainer />;
};

export default Blog2GridRight;
